var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkedLocal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92893 16.3787C3.11929 16.9216 2 17.6716 2 18.5C2 20.1568 6.47715 21.5 12 21.5C17.5229 21.5 22 20.1568 22 18.5C22 17.6716 20.8807 16.9216 19.0711 16.3787",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5C12 17.5 18.5 13.252 18.5 8.3409C18.5 4.83892 15.5898 2 12 2C8.41015 2 5.5 4.83892 5.5 8.3409C5.5 13.252 12 17.5 12 17.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11C13.3807 11 14.5 9.8807 14.5 8.5C14.5 7.1193 13.3807 6 12 6C10.6193 6 9.5 7.1193 9.5 8.5C9.5 9.8807 10.6193 11 12 11Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkedLocal);
export default __webpack_public_path__ + "static/media/marked-local.8b0445fb3794eb6166ee934c35ed8b3e.svg";
export { ForwardRef as ReactComponent };